module.exports = __webpack_public_path__ + "04_medium_gray.682af3eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/04_medium_gray.png
// module id = aWkj
// module chunks = 0